import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import "../components/atoms/buttons/button.scss";
import {
  formateoFecha,
  formateoNumeroEuro,
  getFechaFromUtilTimeStamp,
} from "./Utils";


const ConstantesTabla = {
  columnasUsuarios: [
    { name: "DNI", selector: (row) => row.dni, sortable: true },
    { name: "Nombre", selector: (row) => row.nombre, sortable: true },
    { name: "Apellidos", selector: (row) => row.apellidos, sortable: true },
  ],
  columnasTablaNomina: [
    {
      name: "COD.",
      selector: (row) => row.codigo,
      sortable: true,
      cell: (row) =>
        row.codigo === "TOTALES" ? (
          <div className="fw-bold">{row.codigo}</div>
        ) : (
          row.codigo
        ),
    },
    {
      name: "CONCEPTO",
      selector: (row) => row.concepto,
      sortable: true,
      wrap: true,
    },
    {
      name: "UNIDADES-BASE",
      selector: (row) => row.uniBase,
      sortable: true,
      wrap: true,
      cell: (row) =>
        row.codigo === "TOTALES"
          ? null
          : formateoNumeroEuro(row.uniBase) !== "0,00"
            ? formateoNumeroEuro(row.uniBase)
            : null,
    },
    {
      name: "%",
      selector: (row) => row.porcentaje,
      sortable: true,
      wrap: true,
      cell: (row) =>
        row.codigo === "TOTALES"
          ? null
          : formateoNumeroEuro(row.porcentaje) !== "0,00"
            ? formateoNumeroEuro(row.porcentaje)
            : null,
    },
    {
      name: "DEVENGOS",
      selector: (row) => row.devengo,
      sortable: true,
      wrap: true,
      cell: (row) =>
        row.codigo === "TOTALES" ? (
          <div className="fw-bold">
            {formateoNumeroEuro(row.devengo) !== "0,00"
              ? formateoNumeroEuro(row.devengo)
              : null}
          </div>
        ) : formateoNumeroEuro(row.devengo) !== "0,00" ? (
          formateoNumeroEuro(row.devengo)
        ) : null,
    },
    {
      name: "RETENCIONES",
      selector: (row) => row.retencion,
      sortable: true,
      wrap: true,
      cell: (row) =>
        row.codigo === "TOTALES" ? (
          <div className="fw-bold">
            {formateoNumeroEuro(row.retenciones) !== "0,00"
              ? formateoNumeroEuro(row.retenciones)
              : null}
          </div>
        ) : formateoNumeroEuro(row.retencion) !== "0,00" ? (
          formateoNumeroEuro(row.retencion)
        ) : null,
      grow: 1,
    },
  ],

  columnasReconocimientos: [
    {
      name: "Nombre",
      selector: (row) => row.agno,
      sortable: true,
      left: true,
      grow: 3,
    },
  ],
  columnasBorradoresActos: [
    {
      name: "Nombre",
      selector: (row) => row.nombre,
      sortable: false,
      left: true,
      grow: 2,
      wrap: 1
    },
    {
      name: <div>Fecha y hora</div>,
      selector: (row) => getFechaFromUtilTimeStamp(row.fborrador),
      sortable: true,
      left: true,
      grow: 1,
      wrap: 1
    },
  ],

  columnasActosPresentados: [
    {
      name: "Nombre",
      selector: (row) => row.nombre,
      sortable: false,
      left: true,
      grow: 3,
      wrap: 1,
    },
    {
      name: <div>Fecha y hora</div>,
      selector: (row) => getFechaFromUtilTimeStamp(row.fpresentado),
      sortable: true,
      left: true,
      grow: 4,
      wrap: 1,
      conditionalCellStyles: [
        {
          when: (row) => row.estado === "ANULADA",
          style: { color: "red" },

        },
      ],
      style: {
        fontWeight: "bold",
        // flexGrow : "7 !important"
      },
    },
    {
      name: "Estado",
      selector: (row) =>
        row.estado.startsWith("RESOL") ? "RESOLUCIÓN" : row.estado,
      sortable: true,
      center: true,
      grow: 3,
      cell: (row) => (
        <div
          title={row.estado.startsWith("RESOL") ? "RESOLUCIÓN" : row.estado} // tooltip al pasar el mouse
          style={{
            color: row.estado === "ANULADA" ? "red" : "inherit",
            fontWeight: row.estado === "ANULADA" ? "bold" : "normal",
          }}
        >
          {row.estado.startsWith("RESOL") ? "RESOLUCIÓN" : row.estado}
        </div>
      ),
    }

  ],

  columnasSolicitudesA1A2: [
    {
      name: "Estado",
      selector: (row) => row.estado,
      sortable: true,
      left: true,
      grow: 3,
    },
    {
      name: "Fecha",
      selector: (row) => formateoFecha(row.fechacreacion),
      sortable: true,
      left: true,
      grow: 3,
    },
  ],

  columnasSolicitudes: [
    {
      name: "Código",
      selector: (row) => row.codigo,
      sortable: true,
      left: true,
      grow: 3,
    },
    {
      name: "Estado",
      selector: (row) => row.estadoMostrar,
      sortable: true,
      left: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "Fecha",
      selector: (row) =>
        row.fechaResolucion !== null
          ? `(Notificada: ${formateoFecha(row.fechaResolucion)})`
          : null,
      sortable: true,
      left: true,
      grow: 5,
    },
  ],

  columnasSolicitudesConcursos: {
    name: "Nombre de la solicitud",
    selector: (row) => row.descsolicitud,
    cell: row => (<div>{row.descsolicitud}</div>),
    sortable: true,
    left: true,
    grow: 3,
  },
  columnasTablaAnexos: {
    name: <h3 className="tituloAccesibilidadTab">ANEXOS</h3>,
    selector: (row) => row.nombre,
    left: true,
    grow: 3,
  },
  columnasTablaAsuntos: [
    {
      name: "Tipo",
      selector: (row) => row.tipoVacaciones,
      sortable: true,
      right: true,
    },
    { name: "Desde", selector: (row) => row.fechaDesde, sortable: true },
    { name: "Hasta", selector: (row) => row.fechaHasta, sortable: true },
    { name: "Hora Desde", selector: (row) => row.horaDesde, sortable: true },
    { name: "Hora Hasta", selector: (row) => row.horaHasta, sortable: true },
    {
      name: "Días Solicitados",
      selector: (row) => row.diasSolicitados,
      sortable: true,
    },
    { name: "Estado", selector: (row) => row.estado, sortable: true },
    {
      name: "Comentarios",
      selector: (row) => row.observaciones,
      sortable: true,
    },
  ],

  columnasTablaSeleccionResumen: [
    {
      name: "Tipo",
      selector: (row) => row.tipoVacaciones,
      sortable: true,
      right: true,
    },
    { name: "Desde", selector: (row) => row.fechaDesde, sortable: true },
    { name: "Hasta", selector: (row) => row.fechaHasta, sortable: true },
    { name: "Hora Desde", selector: (row) => row.horaDesde, sortable: true },
    { name: "Hora Hasta", selector: (row) => row.horaHasta, sortable: true },
    {
      name: "Días Solicitados",
      selector: (row) => row.diasSolicitados,
      sortable: true,
    },
    {
      name: "Comentarios",
      selector: (row) => row.observaciones,
      sortable: true,
    },
  ],

  columnasTablaVacaciones: [
    {
      name: "Tipo",
      selector: (row) => row.tipoVacaciones,
      sortable: true,
      right: true,
    },
    { name: "Desde", selector: (row) => row.fechaDesde, sortable: true },
    { name: "Hasta", selector: (row) => row.fechaHasta, sortable: true },
    {
      name: "Días Solicitados",
      selector: (row) => row.diasSolicitados,
      sortable: true,
    },
    { name: "Estado", selector: (row) => row.estado, sortable: true },
    {
      name: "Comentarios",
      selector: (row) => row.observaciones,
      sortable: true,
    },
  ],

  columnasTablaSeleccionPuestos: [
    {
      name: "Código - Denominación Consejería - Centro directivo - Tipo de plaza",
      selector: (row) => (<>
        {}

        <div className="">
          <div className="">
            {row.xpt} - {row.dpt}
          </div>
          <div className="">
            {row.consejeria}
          </div>
          <div className="">
            {row.cdirectivo}
          </div><div className="">
            {row.vacante === "V" ? "VACANTE" : row.vacante === "R" ? "RESULTA" : ""}
          </div>
        </div>
      </>)
      ,

      sortable: true,
      left: true,
      wrap: true,
      grow: 8
    },
    {
      name: "Complemento específico",
      selector: (row) => row.sclacmp,
      sortable: true,
      // center:true,
      grow: 3
    },
    {
      name: "Localización",
      selector: (row) => (<><div className="">{row.localiz.split("(")[0]}</div><div className="">{"(" + row.localiz.split("(")[1]}</div></>),
      sortable: true,
      // center:true,
      wrap: true,
      grow: 2
    },
    {
      name: "Nivel",
      selector: (row) => row.nivel,
      sortable: true,
      canter: true,
    },
  ],



  columnasTablaSeleccionCentros: [
    {
      name: "Localización",
      selector: (row) => row.localizacion,
      sortable: true,
      // center:true,
      wrap: true,
    },
    {
      name: <div>Código - Denominación - Código - Consejería</div>,
      selector: (row) =>
        `${row.codcentro} - ${row.centro} - ${row.codconsejeria} - ${row.consejeria}`,
      sortable: true,
      // left: true,
      wrap: true,
      grow: 2
    },
    {
      name: <div>Categoría Profesional</div>,
      selector: (row) => `${row.categoriaProfesional}`,
      wrap: true,
      sortable: true,
      // center:true,

    },

  ],

  customStyles: {
    rows: {
      style: {
        minHeight: "45px",
        "&:hover": {
          // cursor: "pointer",
          background: "#c2ddca !important",
        },
        "&:hover button": {
          cursor: "pointer",
          background: "#c2ddca !important",
        },
        "&:nth-of-type(even)": {
          backgroundColor: "#F1F1F1",
        },
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        background: "#DBDBDB",
        // color: "#1d873e",
        color: "#00552a",
        fontWeight: "bold",
        fontSize: "16px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        fontSize: "16px",
      },
    },
  },

  //TODO: estilos para poner en la tabla actualizada
  customStyles2: {
    rows: {
      style: {
        minHeight: "45px",
        "&:hover": {
          // cursor: "pointer",
          background: "#c2ddca !important",
        },
        "&:hover button": {
          cursor: "pointer",
          background: "#c2ddca !important",
        },
        "&:nth-of-type(even)": {
          backgroundColor: "#F1F1F1",
        },
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        background: "#DBDBDB",
        // color: "#1d873e",
        color: "#00552a",
        fontWeight: "bold",
        fontSize: "16px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        fontSize: "16px",
      },
    },
  },

  paginacionOpt: {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  },

  conditionalRowStyles: [
    {
      when: (row) => row.gastados < 1,
      style: {
        backgroundColor: "green",
        color: "white",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ],

  columnasEditarAdministradores: [
    {
      name: <div>Nombre Administrador - Usuario</div>,
      selector: (row) =>
        `${row?.nombreadministrador} ${row?.primerapellidoadministrador} ${row?.segundoapellidoadministrador}`,
      grow: 8,
      wrap: true,
      center: true
    },
    {
      name: <div>Usuario</div>,
      selector: (row) =>
        `${row?.nombreusuarioadministrador}`,
      grow: 8,
      wrap: true,
      center: true
    },
  ],

  columnasUsuariosConectados: [
    {
      name: "Código",
      selector: (row) =>
        `${row?.codigo}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Usuario",
      selector: (row) =>
        `${row?.nombreusuario}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "IP",
      selector: (row) =>
        `${row?.ipusuario}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row?.nombre} ${row?.apellido1} ${row?.apellido2}`,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Fecha Y Hora",
      selector: (row) =>
        `${row?.fechahora}`,
      grow: 1,
      wrap: true,
    },
  ],
  columnasAccesosWeb: [
    {
      name: "Código",
      selector: (row) =>
        `${row?.codigo}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Usuario",
      selector: (row) =>
        `${row?.nombreusuario}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "IP",
      selector: (row) =>
        `${row?.ipusuario}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row?.nombre} ${row?.apellido1} ${row?.apellido2}`,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Fecha Y Hora",
      selector: (row) =>
        `${row?.fechahora}`,
      grow: 1,
      wrap: true,
    },
  ],
  columnasAccesosDiaEnCurso: [
    {
      name: "Código",
      selector: (row) =>
        `${row?.codigo}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Usuario",
      selector: (row) =>
        `${row?.nombreusuario}`,
      grow: 1,
      wrap: true,
    },

    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row?.nombre} ${row?.apellido1} ${row?.apellido2}`,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Fecha Y Hora",
      selector: (row) =>
        `${row?.fechahora}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "IP",
      selector: (row) =>
        `${row?.ipusuario}`,
      grow: 1,
      wrap: true,
    }
  ],
  columnasAccesosNominaDiaEnCurso: [
    {
      name: "Código",
      selector: (row) =>
        `${row?.codigo}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Usuario",
      selector: (row) =>
        `${row?.nombreUsuario}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nº Accesos",
      selector: (row) =>
        `${row?.contador}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row?.nombre} ${row?.apellido1} ${row?.apellido2}`,
      grow: 1.5,
      wrap: true,
    },
  ],
  columnasHistorialNoAccesos: [
    {
      name: "Código",
      selector: (row) =>
        `${row?.xpersona}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Usuario",
      selector: (row) =>
        `${row?.nombreusuariousuario}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row?.nombre} ${row?.apellido1} ${row?.apellido2}`,
      grow: 1.5,
      wrap: true,
    },
  ],
  columnasHistorialAccesos: [
    {
      name: "Código",
      selector: (row) =>
        `${row?.codigo}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row?.nombre} ${row?.apellido1} ${row?.apellido2}`,
      grow: 1.5,
      wrap: true,
    },
  ],

  columnasAccesoNomina: [
    {
      name: "Código",
      selector: (row) =>
        `${row?.codigo}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Usuario",
      selector: (row) =>
        `${row?.nombreUsuario}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row?.nombre} ${row?.apellido1} ${row?.apellido2}`,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Fecha",
      selector: (row) =>
        `${row?.fechaHora}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nº Accesos",
      selector: (row) =>
        `${row?.contador}`,
      grow: 1,
      wrap: true,
    }
  ],
  columnasCertificadoDigital: [
    {
      name: "Nombre",
      selector: (row) =>
        `${row?.nombre}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Apellido 1",
      selector: (row) =>
        `${row?.apellido1}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Apellido 2",
      selector: (row) =>
        `${row?.apellido2}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Código",
      selector: (row) =>
        `${row?.codigo} `,
      grow: 1.5,
      wrap: true,
    },
  ],
  columnasBusquedaAccesos: [
    {
      name: "Código",
      selector: (row) =>
        `${row[3]}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "DNI",
      selector: (row) =>
        `${row[4]}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row[0]} ${row[1]} ${row[2]}`,
      grow: 1.5,
      wrap: true,
    },
  ],
  columnasAltaUsuariosWeb: [
    {
      name: "Código",
      selector: (row) =>
        `${row[0]}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "DNI",
      selector: (row) =>
        `${row[4]}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row[1]} ${row[2]} ${row[3]}`,
      grow: 1.5,
      wrap: true,
    },
  ],
  columnasModUsuariosWeb: [
    {
      name: "Código",
      selector: (row) =>
        `${row[3]}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "DNI",
      selector: (row) =>
        `${row[4]}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) =>
        `${row[0]} ${row[1]} ${row[2]}`,
      grow: 1.5,
      wrap: true,
    },
  ],
  columnasModalAlta: [
    {
      name: "DNI",
      selector: (row) =>
        `${row.niep}`,
      grow: 1,
      wrap: true,
    },
    {
      name: "Nombre y Apellidos",
      selector: (row) => (<><div className="text-start">{row.nombre} {row.apellido1} {row.apellido2}</div></>),


      grow: 1.5,
      wrap: true,
    },
    {
      name: "Nombre usuario",
      selector: (row) =>
        `${row.nombreUsuario}`,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Password",
      selector: (row) =>
        `${row.contrasenaEnClaro}`,
      grow: 1,
      wrap: true,
    },
  ],
  columnasVidaAdm: [
    {
      name: "Acto Administrativo",
      selector: (row) =>
        `${row.D_ACTADM}`,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Fecha Inicio efecto",
      selector: (row) =>
        `${row.F_INIEFE}`,
      grow: 1.5,
      wrap: true,
    },

  ],
  columnaTablaPuestosSeleccionado: [
    {
      name: "Orden Actual",
      selector: (row) => (<><div className="ms-2">
        {row.orden}
      </div></>),


      grow: 1,
      wrap: true,
    },
  ],
  columnaTablaCentrosSeleccionado: [
    {
      name: "Orden Actual",
      selector: (row) => (<><div className="ms-2">
        {row.orden}
      </div></>),


      grow: 1,
      wrap: true,
    },
  ],
  columnasServiciosPrestados: [
    {
      name: "Tipo de personal", selector: (row) => row.D_CATPER, sortable: true, grow: 2,
      wrap: true,
    },
    {
      name: "Gr. / Subgr.", selector: (row) => row.GRUPO, sortable: true, grow: 1,
      wrap: true,
    },
    {
      name: "Cuerpo o Categoría/Especialidad", selector: (row) => row.D_CAT, sortable: true, grow: 2.3,
      wrap: true,
    },
    {
      name: "Situación", selector: (row) => row.D_SIT, sortable: true, grow: 1,
      wrap: true,
    },
    {
      name: "Fecha Inicio", selector: (row) => row.INICIO, sortable: true, grow: 1,
      wrap: true,
    },
    {
      name: "Fecha Fin", selector: (row) => row.FIN, sortable: true, grow: 1,
      wrap: true,
    },
    {
      name: "Jornada", selector: (row) => row.JORNADA, sortable: true, grow: 1,
      wrap: true,
    },

  ]
};





export default ConstantesTabla;
